module.exports = __webpack_public_path__ + "static/flux-hifi-3-93f8f51a5c9cd11ada8fce64b1960781.png";